/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kcal/day`)
};

const es_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kcal/día`)
};

const de_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kcal/Tag`)
};

const nl_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kcal/dag`)
};

const fr_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kcal/jour`)
};

const it_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kcal/giorno`)
};

const pt_br2_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kcal/dia`)
};

const pt_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kcal/dia`)
};

const ja_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kcal/日`)
};

const zh_bmr_kcal = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 千卡/天`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ n: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_kcal = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_kcal(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_kcal", locale)
	if (locale === "en") return en_bmr_kcal(inputs)
	if (locale === "es") return es_bmr_kcal(inputs)
	if (locale === "de") return de_bmr_kcal(inputs)
	if (locale === "nl") return nl_bmr_kcal(inputs)
	if (locale === "fr") return fr_bmr_kcal(inputs)
	if (locale === "it") return it_bmr_kcal(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_kcal(inputs)
	if (locale === "pt") return pt_bmr_kcal(inputs)
	if (locale === "ja") return ja_bmr_kcal(inputs)
	return zh_bmr_kcal(inputs)
};